import React from "react";

// Shared drag visuals for placeholder dragging (from the dropdown and for
// moving a chip already in the prompt).
//
// The browser's default drag image is a dashed/outlined snapshot of the
// dragged element that follows the cursor. setDragImage doesn't reliably get
// rid of it, so instead we hand the browser a fully transparent image (nothing
// visible) and draw our own clean pill that follows the cursor. That leaves
// only: the OS mouse pointer, our pill, and the editor's blinking insert line.

// A 1x1 transparent GIF, created once so it's loaded before any drag starts.
const TRANSPARENT_IMG = (() => {
  const img = new Image();
  img.src =
    "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
  return img;
})();

let ghostEl: HTMLElement | null = null;

const removeGhost = () => {
  if (ghostEl) {
    ghostEl.remove();
    ghostEl = null;
  }
};

export function startPlaceholderDrag(e: React.DragEvent, text: string): void {
  // Hide the browser's own drag image entirely.
  e.dataTransfer.setDragImage(TRANSPARENT_IMG, 0, 0);

  removeGhost();
  const el = document.createElement("div");
  el.textContent = text;
  el.style.cssText = [
    "position:fixed",
    "pointer-events:none",
    "z-index:9999",
    "padding:2px 8px",
    "border-radius:6px",
    "font-size:13px",
    "font-family:Inter,Roboto,sans-serif",
    "white-space:nowrap",
    "color:var(--foreground)",
    "background:var(--muted)",
  ].join(";");
  // Sit the pill below-right of the cursor so the insert line above stays clear.
  el.style.left = `${e.clientX + 8}px`;
  el.style.top = `${e.clientY + 16}px`;
  document.body.appendChild(el);
  ghostEl = el;

  const move = (ev: DragEvent) => {
    if (!ghostEl) return;
    ghostEl.style.left = `${ev.clientX + 8}px`;
    ghostEl.style.top = `${ev.clientY + 16}px`;
  };
  const end = () => {
    document.removeEventListener("dragover", move);
    document.removeEventListener("dragend", end);
    document.removeEventListener("drop", end);
    removeGhost();
  };
  document.addEventListener("dragover", move);
  document.addEventListener("dragend", end);
  document.addEventListener("drop", end);
}
